// extracted by mini-css-extract-plugin
export default {"heroHeader":"heroHeader_hh64Z","heroHeaderContainer":"heroHeaderContainer_OriMn"};